import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import DarkModeSwitch from '../components/DarkModeSwitch.jsx';
import LanguageSwitch from '../components/LanguageSwitch.jsx';
import { translations } from '../utils/translations.js';

const Navigation = ({ isDarkMode, setIsDarkMode, language, setLanguage }) => {
  const t = translations[language];
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  
  // Función para manejar el scroll al principio de la página
  const handleScrollToTop = (path) => {
    if (location.pathname === path) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  
  return (    <div className="fixed top-0 w-full z-50">      <nav className={`w-full px-4 md:px-12 py-1.5 flex justify-between items-center backdrop-blur-md transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-900/95' : 'bg-stone-200/95'
      }`}>        {/* Logo */}        <Link 
          to="/" 
          onClick={() => handleScrollToTop('/')}
          className="transition-opacity duration-300 hover:opacity-80 flex-shrink-0 mr-1"
        >
          <img 
            src={isDarkMode ? "/img/logo_darkmode.png" : "/img/logo_lightmode.png"}
            alt="ine"
            className="w-auto h-[50px] md:h-[62px]"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">          <ul className="flex gap-8">
            <li>
              <Link 
                to="/conocimientos" 
                onClick={() => handleScrollToTop('/conocimientos')}
                className={`font-medium transition-colors duration-300 ${
                  isDarkMode 
                    ? 'text-gray-300 hover:text-red-400' 
                    : 'text-gray-700 hover:text-red-900'
                }`}
              >
                {t.knowledge}
              </Link>
            </li>
            <li>
              <Link 
                to="/experiencia" 
                onClick={() => handleScrollToTop('/experiencia')}
                className={`font-medium transition-colors duration-300 ${
                  isDarkMode 
                    ? 'text-gray-300 hover:text-red-400' 
                    : 'text-gray-700 hover:text-red-900'
                }`}
              >
                {t.experience}
              </Link>
            </li>            <li>
              <Link 
                to="/proyectos" 
                onClick={() => handleScrollToTop('/proyectos')}
                className={`font-medium transition-colors duration-300 ${
                  isDarkMode 
                    ? 'text-gray-300 hover:text-red-400' 
                    : 'text-gray-700 hover:text-red-900'
                }`}
              >
                {t.projects}
              </Link>
            </li>
            <li>
              <Link 
                to="/contacto" 
                onClick={() => handleScrollToTop('/contacto')}
                className={`font-medium transition-colors duration-300 ${
                  isDarkMode 
                    ? 'text-gray-300 hover:text-red-400' 
                    : 'text-gray-700 hover:text-red-900'
                }`}
              >
                {t.contact}
              </Link>
            </li>
          </ul>
          
          <div className="flex items-center">
            {/* Dark Mode Switch */}
            <DarkModeSwitch isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
            {/* Language Switch */}
            <LanguageSwitch language={language} setLanguage={setLanguage} isDarkMode={isDarkMode} />
          </div>
        </div>        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center space-x-1">
          {/* Dark Mode Switch */}
          <DarkModeSwitch isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />
          {/* Language Switch */}
          <LanguageSwitch language={language} setLanguage={setLanguage} isDarkMode={isDarkMode} />          {/* Wavy Hamburger Menu */}
          <button
            onClick={toggleMenu}
            className="flex flex-col items-center justify-center w-10 h-10 space-y-0.5 focus:outline-none ml-1"
            aria-label="Toggle menu"
          >            {[...Array(3)].map((_, i) => (
              <svg
                key={i}
                viewBox="0 0 100 20"
                className={`w-7 h-1.5 transition-all duration-300 ${
                  isMenuOpen ? 'opacity-0' : 'opacity-100'
                }`}
                fill="none"
                stroke={isDarkMode ? '#d1d5db' : '#374151'}
                strokeWidth="8"
              >
                <path d="M0 10 Q 25 0, 50 10 T 100 10" />
              </svg>
            ))}
            
            {/* X icon when menu is open */}
            {isMenuOpen && (
              <div className="absolute">
                <svg
                  viewBox="0 0 24 24"
                  className="w-6 h-6"
                  fill="none"
                  stroke={isDarkMode ? '#d1d5db' : '#374151'}
                  strokeWidth="3"
                >
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </div>
            )}
          </button>
        </div>
      </nav>      {/* Mobile Dropdown Menu */}
      <div className={`md:hidden absolute top-full left-0 w-full backdrop-blur-md transition-all duration-300 ease-in-out -mt-px ${
        isDarkMode ? 'bg-gray-900/95' : 'bg-stone-200/95'
      } ${
        isMenuOpen 
          ? 'opacity-100 translate-y-0 visible' 
          : 'opacity-0 -translate-y-4 invisible'
      }`}>        <div className="px-6 py-4 space-y-4">
          <Link 
            to="/conocimientos" 
            onClick={() => {
              toggleMenu();
              handleScrollToTop('/conocimientos');
            }}
            className={`block font-medium py-2 transition-all duration-300 transform hover:translate-x-2 ${
              isDarkMode 
                ? 'text-gray-300 hover:text-red-400' 
                : 'text-gray-700 hover:text-red-900'
            }`}
          >
            {t.knowledge}
          </Link>
          <Link 
            to="/experiencia" 
            onClick={() => {
              toggleMenu();
              handleScrollToTop('/experiencia');
            }}
            className={`block font-medium py-2 transition-all duration-300 transform hover:translate-x-2 ${
              isDarkMode 
                ? 'text-gray-300 hover:text-red-400' 
                : 'text-gray-700 hover:text-red-900'
            }`}
          >
            {t.experience}
          </Link>          <Link 
            to="/proyectos" 
            onClick={() => {
              toggleMenu();
              handleScrollToTop('/proyectos');
            }}
            className={`block font-medium py-2 transition-all duration-300 transform hover:translate-x-2 ${
              isDarkMode 
                ? 'text-gray-300 hover:text-red-400' 
                : 'text-gray-700 hover:text-red-900'
            }`}
          >
            {t.projects}
          </Link>
          <Link 
            to="/contacto" 
            onClick={() => {
              toggleMenu();
              handleScrollToTop('/contacto');
            }}
            className={`block font-medium py-2 transition-all duration-300 transform hover:translate-x-2 ${
              isDarkMode 
                ? 'text-gray-300 hover:text-red-400' 
                : 'text-gray-700 hover:text-red-900'
            }`}
          >
            {t.contact}
          </Link></div>
      </div>
    </div>
  );
};

export default Navigation;
